import { useEffect, useState } from "react";
import RiskAssessmentCard from "../../../../../shared/ui/RiskScoreCard/RiskAssessmentCard";
import { getTenantRiskFactors } from "../../../../../shared/services/apis";
import { useParams } from "react-router-dom";
import RiskSkeleton from "../../../../../shared/ui/RiskScoreCard/RiskSkeleton";

// --- Separated weight functions ---
const getOccupancyWeight = (taskName: string): string => {
  const taskLower = taskName.toLowerCase();

  if (taskLower.includes("current property rents vs. competition"))
    return "20%";
  if (taskLower.includes("aggregate supply projected")) return "20%";
  if (taskLower.includes("occupancy growth projections vs. historic occupancy"))
    return "20%";
  if (
    taskLower.includes("occupancy growth projections vs projected occupancies")
  )
    return "20%";
  if (taskLower.includes("concentrated rent rollover")) return "20%";

  return "0%";
};

const getRentalGrowthWeight = (taskName: string): string => {
  const taskLower = taskName.toLowerCase();
  if (taskLower.includes("rental growth projections vs. market forecasts"))
    return "25%";
  return "0%";
};

const getRevenueWeight = (taskName: string): string => {
  const taskLower = taskName.toLowerCase();
  if (taskLower.includes("revenue growth cagr")) return "40%";
  if (taskLower.includes("overall opex cagr")) return "20%";
  if (taskLower.includes("capital plan implementation risk")) return "40%";
  return "0%";
};

const getOtherCashflowsWeight = (taskName: string): string => {
  const taskLower = taskName.toLowerCase();
  if (taskLower.includes("ti/lc projections")) return "5%";
  if (taskLower.includes("capex maintenance")) return "10%";
  if (taskLower.includes("cash yield")) return "10%";
  if (taskLower.includes("cashflow variation")) return "10%";
  if (taskLower.includes("exit forecasts")) return "25%";
  if (taskLower.includes("dy at exit")) return "15%";
  if (taskLower.includes("ltv at exit")) return "10%";
  if (taskLower.includes("promote")) return "20%";
  return "0%";
};

interface Props {
  RiskFactorId: string;
}

export function ForecastsRiskCard({ RiskFactorId }: Props) {
  const [selectedSubRiskId, setSelectedSubRiskId] = useState<string>("");
  const { tenantId } = useParams<{ tenantId: string }>();
  const [subRiskFactor, setSubRiskFactor] = useState<any[]>([]);
  const [riskPerimeters, setRiskPerimeters] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const refreshRiskScorecard = async () => {
      try {
        setLoading(true);
        console.log(tenantId, "it is in riskscroeooo");
        const response = await getTenantRiskFactors(tenantId || "");
        const riskFactors = response.data || response;
        console.log(riskFactors, "it is in forecasts risk");

        const selectedRiskFactor = riskFactors.find(
          (factor: any) => factor.id === RiskFactorId
        );

        if (selectedRiskFactor) {
          const subFactors = selectedRiskFactor.subRiskFactors.map(
            (sub: any) => ({
              id: sub.id,
              name: sub.name,
              tenantId: sub.tenantRiskFactorId,
              weight: sub.weight,
            })
          );

          setSubRiskFactor(subFactors);

          // Set default selection to first sub-risk factor
          if (subFactors.length > 0 && !selectedSubRiskId) {
            setSelectedSubRiskId(subFactors[0].id);
          }

          const defaultSubRiskId =
            subFactors.length > 0 ? subFactors[0].id : "";
          if (!selectedSubRiskId) setSelectedSubRiskId(defaultSubRiskId);

          // Set risk perimeters based on currently selected sub-risk factor
          // const currentSubRiskId = selectedSubRiskId || defaultSubRiskId;
          setRiskPerimeters(
            selectedRiskFactor.factorGroups
              .filter((group: any) => group.riskFactorId === RiskFactorId)
              .flatMap(
                (group: any) =>
                  group.result?.ratings?.map((rating: any) => ({
                    task: rating.task,
                    rating: rating.rating,
                    reasoning: rating.reasoning,
                    subRiskFactorId: group.subRiskFactorId,
                  })) || []
              )
          );
        } else {
          setSubRiskFactor([]);
          setRiskPerimeters([]);
        }

        console.log(subRiskFactor, "sub Facuturrdsssss");
        console.log(riskPerimeters, "risk parameters");
      } catch (error) {
        console.error("Failed to fetch risk factors:", error);
      } finally {
        setLoading(false);
      }
    };

    refreshRiskScorecard();
  }, [tenantId, RiskFactorId, selectedSubRiskId]);

  useEffect(() => {
    console.log(riskPerimeters, "freee use effect");
  }, [subRiskFactor, riskPerimeters]);

  // Filter risk parameters by selected sub-risk factor
  // const filteredRiskPerimeters = {
  //   ratings: riskPerimeters
  //     .filter((param) => param.subRiskFactorId === selectedSubRiskId)
  //     .map((param) => ({
  //       task: param.task,
  //       rating: param.rating,
  //       reasoning: param.reasoning,
  //     })),
  // };

  // Get weight function based on selected sub-risk factor
  // const getWeightFunction = () => {
  //   const selectedSubFactor = subRiskFactor.find(
  //     (sub) => sub.id === selectedSubRiskId
  //   );
  //   const subFactorName = selectedSubFactor?.name?.toLowerCase() || "";

  //   if (subFactorName.includes("occupancy")) {
  //     return getOccupancyWeight;
  //   } else if (
  //     subFactorName.includes("rental") ||
  //     subFactorName.includes("growth")
  //   ) {
  //     return getRentalGrowthWeight;
  //   } else if (
  //     subFactorName.includes("revenue") ||
  //     subFactorName.includes("noi")
  //   ) {
  //     return getRevenueWeight;
  //   } else if (
  //     subFactorName.includes("cashflow") ||
  //     subFactorName.includes("other")
  //   ) {
  //     return getOtherCashflowsWeight;
  //   }
  //   return getOccupancyWeight; // default
  // };

  // Show loading state
  if (loading) {
    return <RiskSkeleton />;
  }

  // Don't render until we have data
  if (subRiskFactor.length === 0) {
    return <div>No risk data available</div>;
  }

  return (
    <div className="px-4">
      {/* Show buttons only if more than one subRiskFactor exists */}
      {/* {subRiskFactor.length > 1 && (
        <div className="flex justify-center space-x-2 mb-4">
          {subRiskFactor.map((subFactor) => (
            <button
              key={subFactor.id}
              className={`px-3 py-1 text-sm font-light rounded-2xl border cursor-pointer transition-colors duration-200 ${
                selectedSubRiskId === subFactor.id
                  ? "bg-gray-50 text-gray-700 border-gray-300"
                  : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50"
              }`}
              onClick={() => setSelectedSubRiskId(subFactor.id)}
            >
              {subFactor.name}
            </button>
          ))}
        </div>
      )} */}

      {/* Render RiskAssessmentCard for each subRiskFactor */}
      {subRiskFactor.map((sub) => {
        const subFiltered = {
          ratings: riskPerimeters
            .filter((param) => param.subRiskFactorId === sub.id)
            .map((param) => ({
              task: param.task,
              rating: param.rating,
              reasoning: param.reasoning,
            })),
        };

        const getWeightFunction = () => {
          const subName = sub.name.toLowerCase();
          if (subName.includes("occupancy")) return getOccupancyWeight;
          if (subName.includes("rental") || subName.includes("growth"))
            return getRentalGrowthWeight;
          if (subName.includes("revenue") || subName.includes("noi"))
            return getRevenueWeight;
          if (subName.includes("cashflow") || subName.includes("other"))
            return getOtherCashflowsWeight;
          return getOccupancyWeight; 
        };

        return (
          <RiskAssessmentCard
            key={sub.id}
            title={sub.name || "Forcast Risk"}
            apiResponse={subFiltered}
            getWeightForTask={getWeightFunction()}
          />
        );
      })}
    </div>
  );
}
